export default "__VITE_ASSET__Ln$$EeVy__"